import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { OnboardingStages } from "@/features/onboarding/components/onboarding-stages"
import { onboardingQueries } from "@/queries/onboarding"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(onboardingQueries.firm(params.firmId)),
  component: FirmOnboardingPage,
})

function FirmOnboardingPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader title="Onboarding" />
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-10">
        <OnboardingStages firmId={firmId} />
      </div>
    </>
  )
}
